'use client'

import Link from 'next/link'
import React, { useEffect } from 'react'

import DynamicIcon from '@/components/primitives/DynamicIcon/DynamicIcon'
import { cn } from '@/lib/utils'

import type { ContentNavigationType } from '@/types/contentful/contentNavigationType'

export const ContentNavigation = ({ data }: { data?: ContentNavigationType }) => {
  const [selectedContent, setSelectedContent] = React.useState<string | null>(null)

  useEffect(() => {
    if (window && typeof window !== undefined) {
      setSelectedContent(window.location.hash)
    }
  }, [])

  if (!data || !data.fields) return null
  const { links } = data.fields

  if (!links?.length) return null

  const clickHandler = (url: string) => {
    const targetId = url.replace('#', '')
    const targetElement = document.getElementById(targetId)
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
    setSelectedContent(url)
  }

  return (
    <ul className="no-scrollbar flex w-full flex-row overflow-scroll border border-grey-200 bg-white shadow-lg lg:w-[308px] lg:flex-col lg:gap-2 lg:rounded-xl lg:py-4 ">
      {links.map((link, index) => {
        const { url, icon, label } = link.fields
        const isActive = selectedContent ? selectedContent == url : index === 0

        return (
          <li key={label}>
            <Link
              scroll={false}
              href={url}
              onClick={() => clickHandler(url)}
              className={cn(
                'flex items-center gap-x-3',
                'group border-b-[3px] border-transparent p-4 hover:border-primary-500 hover:text-primary-500 lg:border-b-0 lg:border-l-5 lg:py-4 lg:pl-8',
                isActive && 'border-b-[3px] border-primary-500 text-primary-500 lg:border-b-0 lg:border-l-5',
              )}
            >
              {!!icon && <DynamicIcon name={icon} weight="bold" className={cn('size-6 text-grey-500 group-hover:text-primary-500 lg:size-6', isActive && 'text-primary-500')} />}
              <p className="whitespace-nowrap text-base font-medium">{label}</p>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
